export const appAngleRightIcon = {
    data: `<svg viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L11 11L1 21" stroke="#375EC0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'angle-right'
};